import { createFileRoute } from '@tanstack/react-router';
import { WHITEBOARD_TEMPLATES, type WhiteboardTemplate } from '@regent/shared';
import { WhiteboardPage } from '@/features/whiteboards/whiteboard-page';

export const Route = createFileRoute('/w/$workspaceId/whiteboards/$boardId')({
  // `?template=` seeds a brand new board once.
  validateSearch: (search: Record<string, unknown>): { template?: WhiteboardTemplate } => ({
    ...(WHITEBOARD_TEMPLATES.includes(search.template as WhiteboardTemplate) ? { template: search.template as WhiteboardTemplate } : {}),
  }),
  component: BoardRoute,
});

function BoardRoute() {
  const { boardId } = Route.useParams();
  const { template } = Route.useSearch();
  return <WhiteboardPage key={boardId} boardId={boardId} template={template} />;
}
